export default __webpack_public_path__ + "static/hp-brand-deck-07-056d6e39dc001e646550e909a2e80f69.png";